module.exports = __webpack_public_path__ + "bf.8471d39b50e2ff319b49.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/bf.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/bf.svg
// module chunks = styles